import type { FC } from 'react';

import { StorefrontContainer } from '@/features/storefront/components/StorefrontContainer';
import type { ProductViewProps } from '@/features/storefront/layouts/product/types';
import { PartRegion } from '@/features/storefront/parts/PartRegion';

/**
 * A jeweller's product page: the piece a little wider than the buy column,
 * which sticks beside it on a wide screen. The folded panels, the related
 * pieces and the breadcrumb are drawn by the page itself above and below.
 */
export const Product: FC<ProductViewProps> = () => (
  <StorefrontContainer className="grid gap-10 py-10 lg:grid-cols-[minmax(0,1.1fr)_minmax(0,1fr)] lg:gap-14">
    <PartRegion name="gallery" className="min-w-0" />
    <PartRegion name="main" className="min-w-0 lg:sticky lg:top-32 lg:self-start" />
  </StorefrontContainer>
);
